import React, { useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Briefcase, People, Layers, Award } from "react-bootstrap-icons";
import SEO from "../components/SEO";
import AOS from "aos";
import "aos/dist/aos.css";
import julius3 from "../assets/julius3.jpg";
import julius_student from "../assets/julius_student.jpg";

function AboutSection() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const handleLetsTalk = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
    <SEO
        title="About Julius Adeleke - Founder of Adeleke Tennis Academy"
        description="Learn more about Julius Adeleke, a professional tennis coach in the US and founder of Adeleke Tennis Academy."
        keywords="About Julius Adeleke, Tennis Coach Biography, Adeleke Tennis Academy Founder"
        url="https://www.adeleketennisacademy.com/aboutme"
        image="https://julius-s-adeleke.web.app/public/julius.jpg"
      />
    <section>
      <img
  src={julius_student}
  alt="Julius S Adeleke"
  className="img-fluid"
  style={{
    width: "100%",
    height: "100vh",
    objectFit: "cover",
    objectPosition: "center 30%", // 👈 FIX: pushes image down so head is visible
    paddingTop: "20px"
  }}
/>

      <Container className="py-5">
        <Row className="align-items-center">
          {/* Left Section - Image */}
<Col xs={12} md={5} className="d-flex justify-content-center mb-4 mb-md-0 mt-md-n4 mt-lg-n5">
  <div data-aos="zoom-in">
    <img
      src={julius3}
      alt="Julius S Adeleke"
      className="p-1 rotating-image img-fluid"
      style={{
        width: "600px", // Default for mobile
        height: "auto",
      }}
      onLoad={(e) => {
        if (window.innerWidth >= 768 && window.innerWidth < 1200) {
          e.target.style.width = "500px"; // Medium screens
        } else if (window.innerWidth >= 1200) {
          e.target.style.width = "600px"; // Large screens
        }
      }}
    />
  </div>
</Col>


          {/* Right Section - Text & Cards */}
          <Col xs={12} md={7} data-aos="fade-up" style={{ paddingTop: 20 }}>
            <h6 className="text-uppercase text-secondary">Get to know</h6>
            <h2 className="fw-bold text-white fs-3">About Me</h2>

            {/* About Me Text */}
            <p className="text-white mt-4 mt-md-5" data-aos="slide-right" style={{ fontFamily: 'Times New Roman' }}>
              <span className="text-primary">Julius S Adeleke, Founder of Adeleke Tennis Academy (ATA).</span> I am a highly experienced and Certified Tennis Coach dedicated to helping players of all ages and skill levels improve their game. With a proven track record of developing top-quality players. I provide Personalized Coaching, Expert Guidance, and Unwavering Support to ensure each players reaches their full potential.
            </p>

            {/* Cards Section */}
            <Row className="mt-4 g-3">
              {[
                { icon: <Briefcase size={40} className="text-white mb-3" />, title: "Coaching Experience", text: "10+ Years of Coaching Experience" },
                { icon: <People size={40} className="text-white mb-3" />, title: "Students", text: "Worked with players of all ages and skill levels" },
                { icon: <Layers size={40} className="text-white mb-3" />, title: "Clinics", text: "Developed and implemented customized training programs" },
                { icon: <Award size={40} className="text-white mb-3" />, title: "Certificate", text: "Certified Tennis Professional (CTP) | PTR Level 1 and 2" }
              ].map((card, index) => (
                <Col xs={12} sm={6} md={6} lg={4} key={index} data-aos="flip-left">
                  <Card className="custom-card h-100">
                    <Card.Body style={{ backgroundColor: "#000000", borderRadius: 10 }}>
                      {card.icon}
                      <Card.Title className="fw-bold text-white">{card.title}</Card.Title>
                      <Card.Text className="text-white">{card.text}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>

            {/* Coaching Philosophy */}
            <h3 className="mt-5 fw-bold text-white" data-aos="slide-left">Coaching Philosophy</h3>
            <p className="text-white" data-aos="fade-left" style={{ fontFamily: 'Times New Roman' }}>
              "My Coaching Philosophy is centered around creating a positive, supportive, and challenging environment that allows players to grow, learn, and thrive. I believe in
              emphasizing proper technique, Strategy, and Sportsmanship while also fostering a love for the game."
            </p>

            {/* Call-to-Action Button */}
            <div data-aos="zoom-in-up" className="mt-4">
              <Button variant="secondary" onClick={handleLetsTalk} href="/contact" className="animated-button">Let's Talk</Button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
    </>
  );
}

export default AboutSection;
